import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";

const configureFirebasePerformance = () => {
  if (process.env.REACT_APP_CLIENT_ENV === 'staging') {
    return;
  }
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIRBASE_AUTHDOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
  // let performance_standalone = 'https://www.gstatic.com/firebasejs/7.13.2/firebase-performance-standalone.js';
  // // Initialize Firebase
  //   (function(sa,fbc){function load(f,c){var a=document.createElement('script');
  //     a.async=1;a.src=f;var s=document.getElementsByTagName('script')[0];
  //     s.parentNode.insertBefore(a,s);}load(sa);
  //     window.addEventListener('load',function(){
  //       firebase.initializeApp(fbc).performance();
  //     });
  //   })(performance_standalone, firebaseConfig);
  const app = initializeApp(firebaseConfig);
  const perf = getPerformance(app);
};

class performanceTracesManager {
  constructor() {
    this.tracesManager = {};
  }

  getExistingTrace(traceName) {
    return this.tracesManager[traceName];
  }

  startEventTrace({ traceName }) {
    try {
      this.tracesManager[traceName] = firebase.performance().trace(traceName);
      this.tracesManager[traceName].start();
    } catch (error) {
      console.log('Trace cannot be started');
    }
  }

  stopEventTrace({ traceName }) {
    try {
      this.tracesManager[traceName].stop();
      delete this.tracesManager[traceName];
    } catch (error) {
      console.log('Trace cannot be stopped');
    }
  }
}

export default {
  configureFirebasePerformance,
  performanceTrace: new performanceTracesManager(),
};
